const footerLinks = [
  { label: "傍晚新料", href: "#focus" },
  { label: "大图爆料", href: "#wall" },
  { label: "前后对比", href: "#compare" },
  { label: "当事人回应", href: "#reply" },
  { label: "网友热议", href: "#talk" },
  { label: "吃瓜时间轴", href: "#timeline" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-secondary-50/70">
      <div className="mx-auto w-full max-w-page px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-sun-line text-lg" />
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-950">黑料六点</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              傍晚六点的吃瓜高峰，我们把傍晚新料和晚间吃瓜内容集中在一起，
              下班路上、晚饭桌旁都能顺手看。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-10 gap-y-3 sm:grid-cols-2">
            {footerLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/80 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 黑料六点 · 本站为静态演示页面，内容均为占位示例。
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span>傍晚爆料</span>
            <span>晚间吃瓜</span>
            <span>下班看料</span>
          </p>
        </div>
      </div>
    </footer>
  );
}